import { createContext, useContext } from "react";
interface ILoadingContext {
  showLoading: () => void;
  hideLoading: () => void;
  isLoading: boolean;
}
export const LoadingContext = createContext<ILoadingContext>({
  showLoading: () => {
    //showLoading
  },
  hideLoading: () => {
    //hideLoading
  },
  isLoading: false,
});

export const useLoading = () => {
  return useContext(LoadingContext);
};
